import MicroModal from 'micromodal';

const closeMicroModals = () => {
  $('.micromodal[aria-hidden="false"]').each((_, modal) => {
    MicroModal.close(modal.id);
  });
};

const closeBsModals = () => {
  if ($('.modal.in').length) {
    $('.modal.in').modal('hide');
  }
  closeMicroModals();
};

const closeRemodals = () => {
  if (!$('.remodal.remodal-is-opened').length) return;
  $('.remodal.remodal-is-opened').remodal().close();
  $('.remodal-overlay').remove();
  $('.remodal-wrapper').remove();
  const padding = $('body').css('padding-right');
  $('.remodal-fixed-section').css('padding-right', padding);
  document.documentElement.classList.remove('remodal-is-locked');
}

const append = (selector, content) => {
  $(selector).append(content);
};

const html = (selector, content) => {
  $(selector).html(content);
};

const modal = (selector, content) => {
  $(selector).remove();
  $('body').append(content);
  $(selector).modal('show');
};

const microModal = (selector, content) => {
  const id = selector.replace(/^#/, '');
  const currentModal = document.getElementById(id);

  if (currentModal && currentModal.getAttribute('aria-hidden') === 'false') {
    MicroModal.close(id);
  }

  $(selector).remove();
  $('body').append(content);
  MicroModal.show(id, {
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
  });
};

const modalDummy = (content) => {
  document.getElementById('modal_dummy_content').innerHTML = content;
  MicroModal.show('modal_dummy', {
    onClose: modal => modal.querySelector('.micromodal__content').innerHTML = '',
  });
};

const remodal = (selector, content) => {
  $('.remodal-overlay').remove();
  $('.remodal-wrapper').remove();
  $('body').append(content);
  $(selector).last().remodal({ hashTracking: false }).open();
};

const replace = (selector, content) => {
  const $nodes = $(selector);
  $(content).insertAfter($nodes);
  $nodes.hide();
  setTimeout(() => { $nodes.remove(); }, 50);
};

const visit = (url) => {
  window.location = url;
};

export default {
  closeBsModals,
  closeMicroModals,
  closeRemodals,
  append,
  html,
  modal,
  microModal,
  modalDummy,
  remodal,
  replace,
  visit,
};
